import { render, staticRenderFns } from "./DonationPage.vue?vue&type=template&id=5386b800"
import script from "./DonationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DonationPage.vue?vue&type=style&index=0&id=5386b800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports